import type ApiResponseDs from "../../../../core/services/api/type-declerations/response";
import type {PartFormQualificationDs} from "../../../../core/services/api/type-declerations/response";

export interface PartFormQualificationErrorInfo {
    /** User-facing message from the API, when available. */
    message: string | null;
    isCustomerEmailError: boolean;
    errorCode?: number | null;
}

/**
 * Detects BizForm qualification failures caused by missing or invalid customer email.
 */
export function isCustomerEmailQualificationError(message: string | null | undefined): boolean {
    if (!message?.trim()) {
        return false;
    }
    const normalized = message.trim();
    if (!/\bEmail\b/i.test(normalized)) {
        return false;
    }
    return (
        /Validation failed/i.test(normalized)
        || /must not be empty/i.test(normalized)
        || /not a valid email address/i.test(normalized)
    );
}

/**
 * Extracts displayable error details from a failed CheckFormQualificationForPart response.
 */
export function parsePartFormQualificationApiError(
    response: ApiResponseDs<PartFormQualificationDs | null> | undefined,
): PartFormQualificationErrorInfo | null {
    if (!response || response.resultFlag) {
        return null;
    }
    const message = (response.message ?? response.headerTitle ?? "").trim() || null;
    const isCustomerEmailError = Boolean(
        message
        && (
            isCustomerEmailQualificationError(message)
            || (response.errorCode === -607 && /\bEmail\b/i.test(message))
        ),
    );

    return {
        message,
        isCustomerEmailError,
        errorCode: response.errorCode,
    };
}
